import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataMessageModel } from '@core/model/dataMessage.model';

@Component({
  selector: 'app-modal-success',
  templateUrl: './modal-success.component.html',
  styleUrls: ['./modal-success.component.scss']
})
export class ModalSuccessComponent implements OnInit {
  icon: any;
  labelTitile: string;
  textDescription: any;
  status: any;
  button = false;
  onAdd = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataMessage: DataMessageModel
  ) {

    if (this.dataMessage !== null && this.dataMessage !== undefined) {
      this.labelTitile = this.dataMessage.labelTitile;
      this.icon = this.dataMessage.icon;
      this.textDescription = this.dataMessage.textDescription;
      this.status = this.dataMessage.status;
    } else {
      this.labelTitile = 'Lo sentimos parece que algo anda mal';
    }

  }

  ngOnInit() {
  }

  toAssign() {
    this.onAdd.emit();
  }
}
